import { ServiceFactory } from './serviceFactory';
export * from './interfaces';
export { ApiError } from './api/config';

const factory = ServiceFactory.getInstance();
export const mealService = factory.getMealService();
export const userService = factory.getUserService();
export const gamificationService = factory.getGamificationService();